import React from 'react'
import { SortButtons } from '../SortButtons';


/**
 * `activeSortBy` is opt-in. Pass it (the list's current sortBy) and the arrows light up on the
 * ONE column the data is actually sorted by, and a click on any other column starts ascending —
 * so the Date header's first click gives earliest-first. Lists that don't pass it keep the old
 * behaviour, where every column shows the global direction and a click just flips it.
 */
const TableHeaderItem = ({ title, sortBy, sortDirection, callBack, activeSortBy }) => {
  const perColumn = activeSortBy !== undefined;
  const isActive = perColumn ? activeSortBy === sortBy : true;

  const handleSort = React.useCallback((sortBy) => {
    if (perColumn) {
      callBack(isActive && sortDirection === 'asc' ? 'desc' : 'asc', sortBy)
      return;
    }
    if (sortDirection === 'desc') {
      callBack("asc", sortBy)
    }
    else {
      callBack("desc", sortBy)
    }
  }, [perColumn, isActive, sortDirection, callBack])
  return (
    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <p>{title}</p>
      <span className='ml-2'>
        {((perColumn || sortDirection) && sortBy) &&
        <SortButtons
          upActive={isActive && sortDirection == "asc"}
          downActive={isActive && sortDirection == "desc"}
          handleSort={() => handleSort(sortBy)}
        />
        }
      </span>
    </div>
  );
}

export default TableHeaderItem
